export const APPLICATION_RENEWAL_TIME_TYPES = {
  never: 1,
  everyXMonths: 2,
  endOfCurrentYear: 3
};
